<template>
  <vs-popup class="add-new-incoterms" id="popup" :title="'UPDATE REPORT TEMPLATE'" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-incoterms-popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input disabled v-model="form.Name" name="name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="Brand" name="Brand" rules="required" v-slot="{ errors }">
                <small class="label">Brand</small>
                <vs-input disabled v-model="form.Brand" name="name" class="w-full" label="" :danger="!!errors[0]"
                  :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Upload New Template</small>
                <div
                  class="border-2 border-dashed border-gray-300 rounded-lg p-6 mb-6 text-center hover:border-primary cursor-pointer transition-colors duration-300"
                  @click="triggerFileInput" :class="{ 'bg-primary-lighter border-primary': dragover }">
                  <input accept=".docx,.xlsx" ref="fileInput" type="file" class="hidden" @change="onUploadFile" />
                  <i class="text-4xl text-gray-400 mb-2 fas fa-cloud-upload-alt"></i>
                  <p class="text-gray-600 mb-1">Drag and drop files here or click to browse</p>
                  <p class="text-xs text-gray-500">Supported file types: DOCX</p>
                </div>
              </ValidationProvider>
            </div>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const ReportTemplateRepository = RepositoryFactory.get('report_template')

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      Name: '',
      Description: '',
    },
    isCreateMode: true
  }
}

export default {
  name: 'UpdateReportTemplatePopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(data) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        this.form = data
      } catch (error) {

      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    async onUploadFile(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.$vs.loading();
      try {
        let formData = new FormData();
        formData.append('file', file);
        await ReportTemplateRepository.uploadAttachment(this.form._id, formData);
        await this.$parent.onClickRefresh()
        this.open = false
      } catch (e) {
        console.log(e);
      }
      this.$vs.loading.close();
      // Clear the input
      event.target.value = '';
    },
    async onClickCreateSite() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-incoterms-popup',
        scale: 0.45
      })
      try {
        if (this.isCreateMode) {
          await CcpRepository.createCcp(this.form);
          this.showSuccessMessage('CCP item added!');
        } else {
          await CcpRepository.updateCcp(this.id, this.form);
          this.showSuccessMessage('CCP item updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-incoterms-popup > .con-vs-loading')
    },
  },
  components: {
    flatPickr,
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-incoterms>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
